import LiveStreamStatusStore from './live-stream-status-store';

let liveStreamStatusStore: LiveStreamStatusStore | null = null;

const getLiveStreamStatusStore = (): LiveStreamStatusStore => {
  if (liveStreamStatusStore == null) {
    liveStreamStatusStore = new LiveStreamStatusStore();
  }

  return liveStreamStatusStore;
};

export { getLiveStreamStatusStore };
